export default __webpack_public_path__ + "static/media/Bravo.4d42d47b.svg";